import styled from "styled-components";
import { designTokens } from "../../ui/foundation/DesignTokens";

export const MainWraper = styled.div`
  display: flex;
  column-gap: ${designTokens.spacing.lg};
  padding: 4px ${designTokens.spacing.xl};
  grid-area: alert;
  height: fit-content;
  z-index: 1;
  border: 1px solid ${designTokens.colors.gray[100]};
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: ${({ type }) =>
    type === "error" ? designTokens.colors.error[50] :
    type === "warning" ? designTokens.colors.warning[50] :
    type === "success" ? designTokens.colors.success[50] :
    "white"};
`;

export const MessageWrapper = styled.p`
  display: flex;
  gap: ${designTokens.spacing.sm};
  align-items: center;
  font-size: ${designTokens.fontSizes.sm};
  font-family: ${designTokens.fonts.body};
  color: ${({ type }) =>
    type === "error" ? designTokens.colors.error[600] :
    type === "warning" ? designTokens.colors.warning[600] :
    type === "success" ? designTokens.colors.success[600] :
    designTokens.colors.gray[900]};
`;

export const Button = styled.button`
  background: none;
  padding: ${designTokens.spacing.sm};
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: ${designTokens.fontSizes.base};
  font-weight: 700;
  font-family: ${designTokens.fonts.heading};
  border: solid 1px;
  border-radius: ${designTokens.radius.md};
  color: ${({ type }) =>
    type === "error" ? designTokens.colors.error[600] :
    type === "warning" ? designTokens.colors.warning[600] :
    type === "success" ? designTokens.colors.success[600] :
    designTokens.colors.gray[900]};
`;